import { useContext } from './context'
import { useError, useFetch, useRecaptcha } from '@ztechapps/common.hook'
import { useState } from 'react'

export const useVerifyCode = (): [() => Promise<void>, { error: any; loading: boolean }] => {
  const { code, requestId, recaptchaSiteKey, url, ...context } = useContext()
  const { getToken } = useRecaptcha({ recaptchaSiteKey })
  const finalUrl = `${url}/verify`
  const [fetchNow, { error }] = useFetch(finalUrl, { method: 'POST', redirect: 'follow' }, { raw: true })
  const { onError } = useError(error)
  const [loading, setLoading] = useState(false)

  const [, setShowCodeInput] = context.showCodeInput
  const [, setErrorMessage] = context.errorMessage

  const onVerifyCode = async () => {
    try {
      setLoading(true)

      setErrorMessage(null)

      const token = await getToken()

      const response = await fetchNow({
        requestId: requestId[0],
        code: code[0],
        recaptchaToken: token,
      })

      if (response.redirected) {
        window.location.href = response.url
      } else {
        const data = await response.json()
        throw data?.error
      }

      setShowCodeInput(true)
    } catch (e) {
      setErrorMessage(onError(e))
    } finally {
      setLoading(false)
    }
  }

  return [onVerifyCode, { error, loading }]
}
